import React, { useState } from "react";
import "./AddPromotionalBannerComponent.css";
import { Apiurl } from "../../../Pages/utils/page";
import AddPromotionalViewDataModal from "./AddPromotionalViewDataModal";
import AddPromotionalChangePointModal from "./AddPromotionalChangePointModal";
const AddPromotionalBannerComponent = ({
  bannerData,
  handleBannerAnalytics,
  setViewDataModal,
  viewDataModal,
  handleCloseViewDataModal,
  bannerAnalyticData,
  setChangePointModal,
  changePointModal,
  handleCloseChangePointModal,
  setClickedBannerData,
  setImpressionForm,
  impressionForm,
  handleUpdateBannerImpression
}) => {
  return (
    <div className="banner_section" style={{ flex: "1" }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="banner_analytics_section">
              <div className="row">
                <div className="table-responsive custom-table-01">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Sr.No</th>
                        <th>Banner</th>
                        <th>Total No. of Views</th>
                        <th>Linked With</th>
                        <th>Change User</th>
                        <th>Publish</th>
                        <th>Remaining Points</th>
                        <th>Update Remaining Points</th>
                        <th>Change Image</th>
                        <th>No. of Views</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {bannerData?.map((item, index) => {
                        const image = item?.BannerSrc?.split('"');
                        const imageURL = `${Apiurl()}/${image?.[1]}`;
                        return (
                          <tr>
                            <td>{index + 1}</td>
                            <td>
                              <div className="manin_banner_point_wrp">
                                <img
                                  src={imageURL}
                                  className="table_pro_img_wdth_001"
                                  alt="Banner Image"
                                />
                              </div>
                            </td>
                            <td className="tptl_view">{item?.TotalImpression}</td>

                            <td>{item?.LinkedWithUserEmail}</td>

                            <td>
                              <button
                                type="button"
                                className="common_btn btn-secondary"
                              >
                                Change{" "}
                              </button>
                            </td>

                            <td>
                              <div className="form-check form-switch">
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  checked={item?.IsPublish}
                                />
                              </div>
                            </td>
                            <td>{item?.RemainingImpression}</td>
                            <td>
                              <button
                                className="common_btn btn-info"
                                onClick={() => {
                                  setClickedBannerData(item);
                                  setImpressionForm(item?.RemainingImpression)

                                  setChangePointModal(true);
                                }}
                              >
                                Change Points
                              </button>
                            </td>
                            <td className="up_img_wd">
                              <div className="col-12">
                                <button
                                  type="button"
                                  className="common_btn view-data-btn"
                                >
                                  Update Image
                                </button>
                              </div>
                            </td>
                            <td className="tb_view_data_btn">
                              <button
                                className="common_btn btn-info"
                                onClick={() => {
                                  handleBannerAnalytics(item?.Id);
                                  setViewDataModal(true);
                                }}
                              >
                                View Data
                              </button>
                            </td>
                            <td>
                              <div className="col-12">
                                <button className="common_btn btn-danger">
                                  Delete
                                </button>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-lg-12 mb_commn_pd_0">
            <div className="banner_up_load_section">
              <div className="Cus_shadow">
                <form id="imageFormz">
                  <div className="row">
                    <div className="col-lg-4 col-sm-5 col-12">
                      <div className="form-group">
                        <label>Select Banner Image</label>
                        <input
                          className="form-control custom-file-input"
                          accept="image/png, image/jpeg, image/gif"
                          id="inputFile"
                          type="file"
                          _bl_7406660d-edfc-46ec-a6d1-01e59ea06b80=""
                        />
                      </div>
                    </div>

                    <div className="col-lg-2 col-sm-2 col-12 upload_new_img gap-2">
                      <button
                        className="common_btn deflt_update_spc btn-primary btn common_btn_pd"
                        type="button"
                      >
                        Upload Image
                      </button>
                    </div>

                    <div className="col-lg-4 col-sm-5 col-12">
                      <div className="form-group">
                        <label>Select User You want to linked with</label>
                        <select
                          name=""
                          id=""
                          className="form-control custom-file-input"
                        >
                          <option value="">select</option>
                          <option value="gobindcityinfomart@gmail.com">
                            gobindcityinfomart@gmail.com
                          </option>
                        </select>

                        <div>
                          <input type="checkbox" />
                          <label>AllowAnonymous</label>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form-group vendor_bnr_sec">
                        <img className="vendor_banner_show" id="defaultBanner" />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddPromotionalViewDataModal
        viewDataModal={viewDataModal}
        handleCloseViewDataModal={handleCloseViewDataModal}
        bannerAnalyticData={bannerAnalyticData}
      />

      <AddPromotionalChangePointModal changePointModal={changePointModal} handleCloseChangePointModal={handleCloseChangePointModal}
      setImpressionForm={setImpressionForm} impressionForm={impressionForm}
      handleUpdateBannerImpression={handleUpdateBannerImpression}

      />
    </div>
  );
};

export default AddPromotionalBannerComponent;
